import { render, staticRenderFns } from "./common-card.vue?vue&type=template&id=2f6a28b6&scoped=true"
import script from "./common-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./common-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./common-card.vue?vue&type=style&index=0&id=2f6a28b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6a28b6",
  null
  
)

export default component.exports